var _mask;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Email = function Email(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 16 16",
    children: [/*#__PURE__*/_jsx("path", {
      fill: ignoreColor ? undefined : color,
      fillRule: "evenodd",
      d: "M12.666 12H3.333a.667.667 0 01-.667-.667v-6.5l4.934 3.7a.663.663 0 00.8 0l4.933-3.7v6.5c0 .368-.3.667-.667.667zm-.444-8L8 7.167 3.778 4h8.444zm.444-1.333H3.333c-1.103 0-2 .897-2 2v6.666c0 1.103.897 2 2 2h9.333c1.103 0 2-.897 2-2V4.666c0-1.102-.897-2-2-2z",
      clipRule: "evenodd"
    }), _mask || (_mask = /*#__PURE__*/_jsx("mask", {
      id: "crehana-icons-email",
      width: "14",
      height: "12",
      x: "1",
      y: "2",
      maskUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M12.666 12H3.333a.667.667 0 01-.667-.667v-6.5l4.934 3.7a.663.663 0 00.8 0l4.933-3.7v6.5c0 .368-.3.667-.667.667zm-.444-8L8 7.167 3.778 4h8.444zm.444-1.333H3.333c-1.103 0-2 .897-2 2v6.666c0 1.103.897 2 2 2h9.333c1.103 0 2-.897 2-2V4.666c0-1.102-.897-2-2-2z",
        clipRule: "evenodd"
      })
    })), /*#__PURE__*/_jsx("g", {
      mask: "url(#crehana-icons-email)",
      children: /*#__PURE__*/_jsx("path", {
        fill: ignoreColor ? undefined : color,
        d: "M0 0H16V16H0z"
      })
    })]
  });
};
export default Email;